import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import SocialAuthChecker from '../../../../features/components/SocialAuthChecker'
import AdTikTokEdit from '../../../../forms/Tiktok/AdForms/AdTikTokEdit'
import TikTokAdsPreviewList from '../../../CampaignsSummary/AdsList/TikTokAdsPreviewList'
import DisapproveInternalAdModal from '../../DisapproveInternalAdModal'

import useModalManage from '../../../../hooks/useModalManage'

import { getAds, clearAds } from '../../../../modules/actions/ads'
import { selectedTikTokAdAccountSelector } from '../../../../modules/selectors/adAccounts'
import { selectedPartnershipRightsHolderIdSelector } from '../../../../modules/selectors/partnerships'
import { adsSelector } from '../../../../modules/selectors/ads'

import { TIKTOK_PLATFORM } from '../../../../constants/selectLists/platformList'
import { LIFETIME_DATE_PRESET } from '../../../../constants/selectLists/listItemFiltersList'

const TikTokAdsSection = () => {
  const dispatch = useDispatch()

  const ads = useSelector(adsSelector)
  const { id: tikTokAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const partnershipRightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)

  // pass only internal asset groups to GoogleAssetGroupsPreviewList for approval
  const filteredAds = ads.filter(({ approval_status }) => approval_status === 'pending_approval')

  const {
    isModalOpened: isDisapproveInternalAdModalOpened,
    openModalHandler: disapproveInternalAdOpenModalHandler,
    closeModalHandler: disapproveInternalAdCloseModalHandler,
    modalData: disapproveInternalAdModalData
  } = useModalManage({})

  const getInternalAdsData = useCallback(() => {
    dispatch(
      getAds(
        {
          internal: true,
          rights_holder_account_id: partnershipRightsHolderId,
          approval_status: 'pending_approval',
          date_preset: LIFETIME_DATE_PRESET,
          detail: true
        },
        TIKTOK_PLATFORM
      )
    )
  }, [dispatch, partnershipRightsHolderId])

  useEffect(
    () => () => {
      dispatch(clearAds())
    },
    [dispatch]
  )

  return (
    <SocialAuthChecker
      platform={TIKTOK_PLATFORM}
      dataFetch={getInternalAdsData}
      adAccountId={tikTokAdAccountId}
      authFailureText="Please authenticate with TikTok to retrieve the list of ads."
    >
      <TikTokAdsPreviewList
        adsList={filteredAds}
        showStatusChip={false}
        showActionsDropdown={false}
        showDetails={true}
        showMetrics={false}
        showInternalAdActionButtons
        disapproveInternalAdOpenModalHandler={disapproveInternalAdOpenModalHandler}
      />
      <AdTikTokEdit />
      <DisapproveInternalAdModal
        isModalOpened={isDisapproveInternalAdModalOpened}
        modalData={disapproveInternalAdModalData}
        onClose={disapproveInternalAdCloseModalHandler}
      />
    </SocialAuthChecker>
  )
}

export default TikTokAdsSection
